import React from "react";
import RegisterComponent from "../components/RegisterComponent";

const RegisterContainer = () => {
  return <RegisterComponent />;
};

export default RegisterContainer;